import React, { Suspense, useContext } from 'react';
import { ActivityIndicator } from '../../../components/common/activity-indicator/activity-indicator';
import siteMapService from '../../services/site-map-service/site-map-service';
import { scrollToTop } from '../../../components/sections/vehicle-health/vha-utils';
import { buildPath } from '../../../routes';
import { useHistory } from 'react-router-dom';
import VehicleSelectorTabs from '../../../components/common/vehicle-selector-tabs/vehicle-selector-tabs';
import ServerContext from '../../../contexts/serverContext';

interface Props {
    vehicleSelectorTabsLabels: any;
    setQueryVin: (vin: string) => void;
    setDisplayName: (name: string) => void;
}

export const VehicleSelectorTabsContainer = (props: Props) => {
    const history = useHistory();
    const serverContext = useContext(ServerContext);
    const handleVinChange = (newVin: string): void => {
        props.setQueryVin(newVin);
        props.setDisplayName('');
        scrollToTop();
        history.push(
            buildPath('RecallsDetailsPage').replace(':vinOrModel?/:year?/', '')
        );
    };

    return (
        <>
            {props.vehicleSelectorTabsLabels?.vehicleSelectorTabsTitle && (
                <div
                    className="vehicle-selector-tab-container"
                    data-testid="vehicle-selector-tab-container"
                >
                    <Suspense fallback={<ActivityIndicator />}>
                        <VehicleSelectorTabs
                            redirectData={{
                                path:
                                    siteMapService.getPathFromRouterConfigs(
                                        serverContext.currentLanguageRegionCode,
                                        serverContext.brand,
                                        'RecallsDetailsPage',
                                        []
                                    ) || '',
                                id: 'recalls-details',
                            }}
                            content={props.vehicleSelectorTabsLabels}
                            handleVinChange={handleVinChange}
                            ymmSubmitEvent={scrollToTop}
                        />
                        <div className="dropdown-compensation" />
                    </Suspense>
                </div>
            )}
        </>
    );
};
